/* eslint-disable */
import {FuseNavigationItem} from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: "genuine-warranty-list",
        title: "Genuine / Warranty Management",
        type: 'collapsable',
        icon: 'heroicons_outline:shield-check',
        children: [
            {
                id: "warranty-listing",
                title: "Warranty Listing",
                type: 'basic',
                icon: 'heroicons_outline:search',
                link: '/portal/warranty-list'
            }
        ]
    },
    // {
    //     id: "my-profile",
    //     title: "My Profile",
    //     type: 'collapsable',
    //     icon: 'heroicons_outline:user-circle',
    //     children: [
    //         {
    //             id: "change-password",
    //             title: "Change Password",
    //             type: 'basic',
    //             icon: 'heroicons_outline:key',
    //             link: '/portal/my-profile/change-password'
    //         }
    //     ]
    // },
    {
        id: "genuine-points-list",
        title: "Points",
        type: 'collapsable',
        icon: 'heroicons_outline:shield-check',
        children: [
            {
                id: "redeemedPoints-listing",
                title: "Redemption History",
                type: 'basic',
                icon: 'heroicons_outline:search',
                link: '/portal/points/redemption-history'
            }
        ]
    },
    {
        id: "redeem-list",
        title: "Redeem",
        type: 'collapsable',
        icon: 'heroicons_outline:shield-check',
        children: [
            {
                id: "redeem-product-listing",
                title: "Product Redemption",
                type: 'basic',
                icon: 'heroicons_outline:search',
                link: '/portal/redeem/redemption-product'
            },
            {
                id: "redeem-history-listing",
                title: "Redemption History",
                type: 'basic',
                icon: 'heroicons_outline:search',
                link: '/portal/redeem/redemption-history'
            },
        ]
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
